import opApiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { HttpMethods } from 'api/types';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store/index';
import filterHighlightsItems from 'utils/filterHighlightsItems';
import { resetHighlightsAction, setHighlightsAction } from '../slice';
import { HighlightProduct } from '../types';

const MAX_LIMIT = 20;
const MAX_OFFSET = MAX_LIMIT * 50;

const fetchHighlightsOperation =
  (offset = 0, limit = MAX_LIMIT) =>
  async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    let data;
    try {
      data = await opApiRequest<{ orders: HighlightProduct[] }>(
        endpoints.customerOrderV1List,
        {
          offset,
          limit,
          useCache: false,
        },
        HttpMethods.POST,
        'data',
      );
    } catch (e) {
      console.error('Error fetching order items', e);
    }

    if (!data || !data.orders) {
      return;
    }
    const filteredItems = filterHighlightsItems(data.orders);
    if (offset === 0) {
      dispatch(resetHighlightsAction());
    }
    dispatch(setHighlightsAction(filteredItems));
    if (data.orders.length === limit && offset < MAX_OFFSET) {
      dispatch(fetchHighlightsOperation(offset + limit));
    }
  };

export default fetchHighlightsOperation;
